module.exports = __webpack_public_path__ + "af3935de6b25d6075cd710438fc624c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/eg/luckyfruit.jpg
// module id = 643
// module chunks = 30